module.exports = __webpack_public_path__ + "media/tape-nav/content-imh-icon-33329b30.svg";